import { useQuery } from "@apollo/client";
import { getClaims } from "graphql/queries/claims";
import { GetClaimsQuery, GetClaimsQueryVariables } from "graphql/queries/__generated__/claims";

interface UseClaimsParams {
  offerId?: string;
  limit?: number;
  offset?: number;
  dateFrom?: string;
  dateTo?: string;
  currency?: string;
}

export const useClaims = (params?: UseClaimsParams) => {
  const { data, refetch, loading, error } = useQuery<GetClaimsQuery, GetClaimsQueryVariables>(
    getClaims,
    {
      variables: {
        offerId: params?.offerId ?? null,
        limit: params?.limit || 10,
        offset: params?.offset || 0,
        dateFrom: params?.dateFrom ?? null,
        dateTo: params?.dateTo ?? null,
        currency: params?.currency ?? null,
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "network-only",
    }
  );

  const refresh = () => refetch();

  return {
    claims: data?.getClaims || [],
    loading,
    error,
    refresh,
  };
};
